var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoenloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_103",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 0H0.75V20H20.75V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3965 12.3536C10.5918 12.5488 10.9084 12.5488 11.1037 12.3536L14.2856 9.17157C14.4809 8.97631 14.4809 8.65973 14.2856 8.46447C14.0904 8.2692 13.7738 8.2692 13.5785 8.46447L10.7501 11.2929L7.92167 8.46447C7.72641 8.2692 7.40983 8.2692 7.21457 8.46447C7.0193 8.65973 7.0193 8.97631 7.21457 9.17157L10.3965 12.3536ZM10.2501 4V12H11.2501V4H10.2501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14V16H16.75V14",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoenloadIcon);
export default __webpack_public_path__ + "assets/media/doenload-icon.cec8181202452091b5e3bab44abcc71d.svg";
export { ForwardRef as ReactComponent };